export class BaseModel {
  id: string = '';
  created_at: string = '';
  updated_at?: string;

  get isValidObject(): boolean {
    return !!this.id;
  }
}
